import * as React from 'react';
import {Dialog, DialogContent, DialogTitle, ListItemIcon, ListItemText, MenuItem, Typography, WithStyles, withStyles,} from '@material-ui/core';
import Button from '@components/common/button/Button';
import TranslateNew from '@translate/TranslateNew';
import { PopupStyle } from './popup.style';
import AddIcon from '@material-ui/icons/AddCircle';
import EditLocationIcon from '@material-ui/icons/EditLocationRounded';
import DateRangeIcon from '@material-ui/icons/DateRange';
import ClockIcon from '@material-ui/icons/AccessTimeRounded';
import PlaceIcon from '@material-ui/icons/PlaceOutlined';
import { buttonContainedLarge, primaryColor } from 'src/main.style';
import { schoolAgeFromFamily } from '@helpers/schoolHelper';
import { connect } from 'react-redux';
import { ISchedule } from '@app-types/websocket/schedule.types';
import { ICalendarSetting } from '@app-types/websocket/user.types';
import { createArrayCopyAndSort } from '../editPane/editActions/ScheduleCalc';
import { IScheduleEvent } from '@components/calendar2/dayDetails/scheuldeEvent.types';
import { IFamilyMember } from '@app-types/websocket/family.types';
import { FamilyMemberType } from '@services/family/family.constants';
import * as EventActions from '@services/events/event.action';
import { IEvent, ILocalEvent } from '@app-types/websocket/event.types';
import DayEvent from '../dayDetails/DayEvent';
import { IExternalCalenderEvent } from '@app-types/api/externalCalendar.types';
import DayExternalEvent from '../dayDetails/DayExternalEvent';
import DayImportedEvent from '../dayDetails/DayImportedEvent';
import { holidays } from '../holidays/holidays';
import { toIsoDate } from '@helpers/DateHelper';
import { ISuggestion } from '@app-types/websocket/suggestion.types';
import { SUGGESTION_TYPES } from '@constants/suggestionTypes';

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof PopupStyle> {
  open:boolean;
  selectedDay:Date;
  editSchedule:(scheduleId:number, suggestionId:number) => void;
  createEvent:() => void;
  close:() => void;
  family:IFamilyMember[];
  isParent:boolean;
  suggestions:ISuggestion[];

  userId:number;
  events:IEvent[];
  importedEvents:ILocalEvent[];
  externalEvents:IExternalCalenderEvent[];

  schedules:ISchedule[];
  calendarSettings: ICalendarSetting;

  editHandover: (position:"START"|"END"|"DAYVISIT", event:IScheduleEvent) => void
  sleepsAt: (scheduleId:number, parent:number) => void;

  seenEvent: (id:number) => void;
  editEvent: (id:number) => void;
  completedEvent : (eventId:number) => void;
  zoomImage: (url:string|undefined) => void;

  localization:"se"|"en";

  countryHolidays:{ [key:string]:{title:string, type:"HOLIDAY"|"SPECIAL_DAY"}; };
}

interface IState {
  maxHeight: number|undefined;
  callFunction: (() => void)|undefined;
  suggestionId:number|undefined;
  scheduleId:number|undefined;
}


interface IEditHandover {
  position:"START"|"END"|"DAYVISIT";
  event:IScheduleEvent;
}

interface IEditSleepAt {
  currentlySleepsWith:number;
  otherParent:number;
  schedule:ISchedule;
  kids:number[];
}


class DayPopUpMenu extends React.Component<IProps, IState> {
  private timer:NodeJS.Timeout|null = null;
  private paneRef:React.RefObject<HTMLDivElement> = React.createRef();

  constructor(props: IProps) {
    super(props);

    this.state = {
      maxHeight: undefined,
      callFunction:undefined,
      suggestionId:undefined,
      scheduleId:undefined,
    };
    if (props.open){
      this.timer = setTimeout(() =>{
        if (this.paneRef.current){
          this.setState({maxHeight:Math.min(this.paneRef.current.offsetHeight,500)});
        } 
      }, 500);
    }
  }

  public componentWillUnmount(): void {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  public componentDidUpdate(prevProps: Readonly<IProps>): void {
    if (this.props.open !== prevProps.open){
      if (!this.props.open){
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.setState({maxHeight:undefined});
      } else {
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() =>{
            if (this.paneRef.current){
              this.setState({maxHeight:Math.min(this.paneRef.current.offsetHeight,500)});
            }
          }, 500);
      }
    }
  }

  public editHandover(calendarId:number, calledMethod:() => void):void {
    let existingSuggestionId:number|undefined;
    for (const sugg of this.props.suggestions) {
      if (sugg.status === SUGGESTION_TYPES.AWAITING_APPROVAL && sugg.creatorId === this.props.userId && sugg.schedules.includes(calendarId)) {
        existingSuggestionId = sugg.id;
      }
    }
    if ( existingSuggestionId !== undefined) {
      console.log("suggestion" + existingSuggestionId)
      this.setState({suggestionId:existingSuggestionId, scheduleId:calendarId, callFunction:calledMethod});
    } else {
      calledMethod(); 
    }
  }

  public render() {
    const {classes,schedules,calendarSettings, events, selectedDay, importedEvents, externalEvents, countryHolidays} = this.props;
    const activeSchedules:ISchedule[] = []

    const formattedDate = toIsoDate(selectedDay);
    // is this null check really needed?
    const holiday = countryHolidays?.[formattedDate] || null;

    if (calendarSettings && calendarSettings.calendars && calendarSettings.calendars.length > 0) {  
      for (const schedule of schedules) {
        if (calendarSettings.calendars.includes( schedule.id )) {
          activeSchedules.push(schedule);
        }
      }
    }

    const spin = new Date(selectedDay);
    spin.setSeconds(0);
    spin.setMinutes(0);
    spin.setHours(0);

    const start = spin.getTime();

    spin.setSeconds(59);
    spin.setMinutes(59);
    spin.setHours(23);

    const end = spin.getTime();

    const filteredEvents = events.filter(
      (event) =>
        (event.startTime >= start && event.startTime <= end) ||
        (event.endTime >= start && event.endTime <= end) ||
        (event.startTime <= start && event.endTime >= end)
    );

    const combinedEvents:Array<{time:number, event?:IEvent, importedEvent?:ILocalEvent, externalEvent?:IExternalCalenderEvent}> = [];

    for (const te of filteredEvents) {
      combinedEvents.push({
        time: te.startTime,
        event:te,
      });
    }

    for (const ie of importedEvents) {
      if (ie.endTime < start || ie.startTime > end) {
        continue;
      }
      combinedEvents.push({
        time: ie.startTime,
        importedEvent: ie,
      });
    }

    if (externalEvents) {
      for (const ie of externalEvents) {
        combinedEvents.push({
          time: ie.startTime,
          externalEvent:ie,
        });
      }
    }

    combinedEvents.sort((a,b) => {
      if (a.time === b.time) {
          return 0;
      } else {
        return a.time - b.time;
      }
    })

    let holidayElement: JSX.Element | null = null;
    if (holiday) {
      holidayElement = (
        <MenuItem key="HOLIDAY" className={classes.menuListItem}>
          <ListItemIcon>
            <DateRangeIcon/>
          </ListItemIcon>
          <ListItemText>
            <span className={classes.holidayTitle} style={{color: holiday.type === "HOLIDAY" ? "red" : "black",}}>
              {holiday.title}
            </span>
          </ListItemText>
        </MenuItem>
      );
    }

    const renderedEvents:JSX.Element[] = [];
    let id:number = 0;
    for (const event of combinedEvents) {
      id++;
      if (event.event !== undefined) {
        const eventId = event.event.id;
        renderedEvents.push(<DayEvent  
          key={id}
          userId={this.props.userId}
          renderForDate={selectedDay}
          event={event.event}
          localization={this.props.localization}
          family={this.props.family}
        
          showDetails={() => {this.props.editEvent(eventId); this.props.close();}}
          seenEvent={this.props.seenEvent}
          completedBy={this.props.completedEvent}
          zoomImage={this.props.zoomImage}
        />)
      } else if (event.externalEvent !== undefined) {
        renderedEvents.push(<DayExternalEvent userId={this.props.userId}
          key={"ev"+event.externalEvent.id} event={event.externalEvent} family={this.props.family}
          localization={this.props.localization} renderForDate={selectedDay} />)
      } else if (event.importedEvent !== undefined) {
        renderedEvents.push(<DayImportedEvent 
          key={"ie"+event.importedEvent.id} event={event.importedEvent} 
          localization={this.props.localization} renderForDate={selectedDay} />)
      }
    }

    return (
      <div className={classes.popUpMenu} ref={this.paneRef} 
        style={this.state.maxHeight?{maxHeight:this.state.maxHeight, overflowY:'auto'}:{overflow:'auto'}}>
        {holidayElement}
        <MenuItem
          className={classes.menuListItem}
          onClick={() => {this.props.createEvent(); this.props.close();}}>
          <ListItemIcon style={{minWidth:'66px'}}>
            <AddIcon style={{fill:primaryColor}} />
          </ListItemIcon>
          <ListItemText>
            <span style={{display: 'flex', alignItems: 'center'}}>
              {tn.lang.activity}
            </span>
          </ListItemText>
        </MenuItem>
        {this.props.isParent && this.renderQuickChange(activeSchedules, this.props.selectedDay)}
        {renderedEvents}
      </div>
    );
  }

  private renderQuickChange(activeSchedules:ISchedule[], date:Date):JSX.Element[] {

    const start = new Date(date);
    const end = new Date(date);

    start.setMilliseconds(0);
    start.setSeconds(0);
    start.setMinutes(0);
    start.setHours(0);

    end.setMilliseconds(999);
    end.setSeconds(59);
    end.setMinutes(59);
    end.setHours(23);

    const dayStart:number = start.getTime();
    const dayEnd:number = end.getTime();

    const handovers:IEditHandover[] = [];
    const sleepingAt:IEditSleepAt[] = [];

    for (const schedule of activeSchedules) {
      for (const entry of createArrayCopyAndSort(schedule.data.scheduleEntriesParentA)) {
        if (entry.endTime < dayStart) {
          continue;
        }
        if (entry.startTime > dayEnd) {
          break;
        }
        if ((entry.endTime >= dayStart && entry.endTime <= dayEnd  && entry.startTime < dayStart)
          ||(entry.startTime >= dayStart && entry.startTime <= dayEnd  && entry.endTime > dayEnd)) {

          const position = (entry.endTime >= dayStart && entry.endTime <= dayEnd  && entry.startTime < dayStart)?"END":"START";

          handovers.push({
            position,
            event: {
              startAtSchool:entry.startAtSchool,
              endAtSchool:entry.endAtSchool,
              eventId:entry.id,
              schedule,
              children:schedule.data.children,
              parent:schedule.data.parentA,
              startTime:entry.startTime,
              endTime:entry.endTime,
              startLoc:entry.startLoc,
              endLoc:entry.endLoc,
              parentColor:"#ccc", // should not matter
              schedulePosition:1, // should not matter
          
              packingListStatus:"passed", // should not matter
              packingList:[], // should not matter
              hideThis:false, // should not matter
            }
          });
        } else if (entry.startTime > dayStart && entry.endTime < dayEnd) {
          handovers.push({
            position: "DAYVISIT",
            event: {
              startAtSchool:entry.startAtSchool,
              endAtSchool:entry.endAtSchool,
              eventId:entry.id,
              schedule,
              children:schedule.data.children,
              parent:schedule.data.parentA,
              startTime:entry.startTime,
              endTime:entry.endTime,
              startLoc:entry.startLoc,
              endLoc:entry.endLoc,
              parentColor:"#ccc", // should not matter
              schedulePosition:1, // should not matter
          
              packingListStatus:"passed", // should not matter
              packingList:[], // should not matter
              hideThis:false, // should not matter
            }
          });
        } else if (entry.startTime < dayStart && entry.endTime > dayEnd) {
          sleepingAt.push({
            schedule,
            currentlySleepsWith: schedule.data.parentA,
            otherParent: schedule.data.parentB,
            kids:schedule.data.children,
          });
        }
      }
      for (const entry of createArrayCopyAndSort(schedule.data.scheduleEntriesParentB)) {
        if (entry.endTime < dayStart) {
          continue;
        }
        if (entry.startTime > dayEnd) {
          break;
        }
        if (entry.startTime < dayStart && entry.endTime > dayEnd) {
          sleepingAt.push({
            schedule,
            currentlySleepsWith: schedule.data.parentB,
            otherParent: schedule.data.parentA,
            kids:schedule.data.children,
          });
        }
      }
    }

    const elements:JSX.Element[] = [];
    const schoolAge = schoolAgeFromFamily(this.props.family || []);
    handovers.sort((a, b) => handoverTime(a) - handoverTime(b));

    let index = 0;
    for (const handover of handovers) {
      elements.push(
      <MenuItem key = {"h"+index}
        className={this.props.classes.menuListItem}
        onClick={() => {this.editHandover(handover.event.schedule.id, 
          () => {this.props.editHandover(handover.position, handover.event); this.props.close();})}}>
        <ListItemIcon style={{minWidth:'66px'}}>
          <EditLocationIcon />
        </ListItemIcon>
        <ListItemText disableTypography={true}>
          <span style={{display: 'flex', alignItems: 'center', fontSize:'17px', fontWeight:500}}>
            {handover.position === "DAYVISIT"?tn.lang.calDayvisit:tn.lang.schedulePickup}
          </span>
          {this.renderHandoverDetails(handover, schoolAge)}
        </ListItemText>
      </MenuItem>
      );
      index++;
    }

    for (const sleep of sleepingAt) {
      elements.push(
      <MenuItem key = {"c"+index}  
        className={this.props.classes.menuListItem}
        onClick={() => {this.editHandover(sleep.schedule.id, 
          () => {this.props.sleepsAt(sleep.schedule.id, sleep.otherParent); this.props.close();})}}>
        <ListItemIcon style={{minWidth:'66px'}}>
          <div style={{display: 'flex', alignItems: 'center'}}>
            {sleep.kids.map((kid,i) =>tn.avatar(this.props.family, kid, (i > 0?avatarSecondStyle:avatarStyle)))}
          </div>
        </ListItemIcon>
        <ListItemText>
          <span style={{display: 'flex', alignItems: 'center'}}>
            {tn.lang.calQuickChangeResponsibility}
          </span>
        </ListItemText>
      </MenuItem>
      );
      index++;
    }
    
    /* somewhat hacky method of adding this in the menu */
    if (this.state.callFunction !== undefined && this.state.scheduleId !== undefined && this.state.suggestionId !== undefined) {
      elements.push(
        <Dialog
          key="continue"
          open={true}
          onClose={() => this.setState({callFunction:undefined, scheduleId:undefined, suggestionId:undefined})}
        >
          <DialogTitle>{tn.lang.continue}?</DialogTitle>
          <DialogContent>
            <Typography>
              {tn.lang.calExistingSuggestion}
            </Typography>
          </DialogContent>
          <div style={{display: "flex", gap: "10px", margin: "10px"}}> 
            <Button onClick={() => {
              if (this.state.callFunction !== undefined) {this.state.callFunction()};
              this.setState({callFunction:undefined, scheduleId:undefined, suggestionId:undefined});}} >
                {tn.lang.createNew}
            </Button>            
            <Button variant='contained' style={buttonContainedLarge} onClick={() => {
              if (this.state.scheduleId !== undefined && this.state.suggestionId !== undefined) 
                {this.props.editSchedule(this.state.scheduleId,this.state.suggestionId);}
              this.setState({callFunction:undefined, scheduleId:undefined, suggestionId:undefined}); this.props.close(); }}color="primary">
              {tn.lang.update}
            </Button>

          </div>

        </Dialog>
      );
    }

    return elements;
  }

  // Time and place under the handover title, e.g. "13:00 · McDonalds" or "13:00–17:00 · Home".
  private renderHandoverDetails(handover:IEditHandover, schoolAge:number):JSX.Element {
    const {classes} = this.props;
    const event = handover.event;
    const school = tn.lang.calDayVisitSchool(event.schedule.school, schoolAge);
    const startText = event.startAtSchool ? school : tn.formatTime(new Date(event.startTime));
    const endText = event.endAtSchool ? school : tn.formatTime(new Date(event.endTime));

    let time:string;
    const places:string[] = [];
    if (handover.position === "DAYVISIT") {
      time = startText + "–" + endText;
      if (!event.startAtSchool && event.startLoc) {
        places.push(event.startLoc);
      }
      if (!event.endAtSchool && event.endLoc && event.endLoc !== event.startLoc) {
        places.push(event.endLoc);
      }
    } else {
      const atSchool = handover.position === "START" ? event.startAtSchool : event.endAtSchool;
      const loc = handover.position === "START" ? event.startLoc : event.endLoc;
      time = handover.position === "START" ? startText : endText;
      if (!atSchool && loc) {
        places.push(loc);
      }
    }

    return (
      <span className={classes.handoverDetails}>
        <span className={classes.handoverDetail}>
          <ClockIcon className={classes.handoverDetailIcon}/>
          {time}
        </span>
        {places.length > 0 &&
          <span className={classes.handoverDetail + " " + classes.handoverPlace}>
            <PlaceIcon className={classes.handoverDetailIcon}/>
            <span className={classes.handoverPlaceText}>{places.join(" → ")}</span>
          </span>}
      </span>
    );
  }


}

// When the handover in the day happens, used to list the day's handovers in order.
const handoverTime = (handover:IEditHandover):number =>
  handover.position === "END" ? handover.event.endTime : handover.event.startTime;

const avatarStyle:React.CSSProperties = {height:'20px', width:'20px', margin:'1px', border:"1px solid #fff"};
const avatarSecondStyle:React.CSSProperties = {height:'20px', width:'20px', margin:'1px', marginLeft:'-10px', border:"1px solid #fff"};

function mapStateToProps(state: any) {
  const schedules:ISchedule[] =  state.schedule.schedules;
  const calendarSettings: ICalendarSetting = state.user.calendarSettings;
  const userId: number = state.user.session.data.id;
  const family:IFamilyMember[]|undefined = state.family.family;
  const country = (state.user.calendarSettings && state.user.calendarSettings.holidaysCountry )
    ?state.user.calendarSettings.holidaysCountry
    :undefined;
    const countryHolidays = holidays.getHolidays(country)

  let isParent = false;

  if (family) {
    for (const mem of family) {
      if (mem.id === userId) {
        if (mem.role === FamilyMemberType.PARENT ) {
          isParent = true;
        }
      }
    }
  }

  return {
    userId,
    schedules,
    calendarSettings,
    family,
    isParent,
    events:state.event.events?state.event.events:[],
    countryHolidays,
    suggestions:state.suggestion.suggestions?state.suggestion.suggestions:[],
  };
}


const mapDispatchToProps = {
  seenEvent: EventActions.seenEvent,
  completedEvent: EventActions.completedEvent,
};

const sortEvents = (a: IEvent, b: IEvent, dayStart: number, dayEnd: number): number => {
  // return > 0 if a should be before b
  if (a.startTime < dayStart) {
    if (b.startTime < dayStart) {
      return a.startTime - b.startTime;
    } else {
      return -1;
    }
  } else if (b.startTime < dayStart) {
    return 1;
  } else if (a.endTime > dayEnd) {
    if (b.endTime > dayEnd) {
      return a.startTime - b.startTime;
    } else {
      return -1;
    }
  } else if (b.endTime > dayEnd) {
    return 1;
  } else {
    return a.startTime - b.startTime;
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(PopupStyle)(DayPopUpMenu));



// WEBPACK FOOTER //
// ./src/components/calendar2/monthView/DayPopUpMenu.tsx